import React, { useState, useEffect } from "react";
import { Button, Modal } from "react-bootstrap";
import DataTableSearch from "../Common/HelpCommon/DataTableSearch";
import DataTablePagination from "../Common/HelpCommon/DataTablePagination";
import axios from "axios";
import "../App.css";
import Swal from "sweetalert2";

var lActiveInputFeild = "";
const API_URL = process.env.REACT_APP_API;

const AwakEntryhelp = ({ helpMode = "SALE", onAcCodeClick, name, Doc_No, DetailId, onFetchedData, disabledFeild, tabIndexHelp, firstInputRef, farmerCode, enableFetchData = false, enableFarmerFilter = false, resetSelectionTrigger, showPreviewModal, displayFarmerName = "",   // NEW
    displayAwakDate = "",     // NEW
    displayQty = "", }) => {
    const CompanyCode = sessionStorage.getItem("Company_Code")
    const Year_Code = sessionStorage.getItem("Year_Code");
    const [showModal, setShowModal] = useState(false);
    const [popupContent, setPopupContent] = useState([]);
    const [enteredAcCode, setEnteredAcCode] = useState("");
    const [enteredProformaid, setEnteredProformaid] = useState(DetailId || "");
    const [type, setType] = useState("");
    const [searchTerm, setSearchTerm] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;
    const [selectedRowIndex, setSelectedRowIndex] = useState(-1);
    const [apiDataFetched, setApiDataFetched] = useState(false);
    const [selectedItemId, setSelectedItemId] = useState(null);
    const [selectedPattiRows, setSelectedPattiRows] = useState({});
    const [selectedFarmerName, setSelectedFarmerName] = useState("");
    const [selectedAwakDate, setSelectedAwakDate] = useState("");
    const [selectedQty, setSelectedQty] = useState("");



    const isAwakNoHelp = helpMode === "SALE";
    const isPattiHelp = helpMode === "PATTI";




    useEffect(() => {
        setSelectedFarmerName(displayFarmerName || "");
        setSelectedAwakDate(displayAwakDate || "");
        setSelectedQty(displayQty ?? "");
    }, [displayFarmerName, displayAwakDate, displayQty]);

    useEffect(() => {
        if (firstInputRef?.current) {
            firstInputRef.current.focus();
        }
    }, []);

    //  Focus back to input after modal closes
    useEffect(() => {
        if (!showModal && firstInputRef?.current) {
            firstInputRef.current.focus();
        }
    }, [showModal]);

    const getHelpApiUrl = () => {
        if (helpMode === "ADVANCE") {
            return `${API_URL}/AwakNoHelpForAdvance?Company_Code=${CompanyCode}`;
        }
        if (helpMode === "PATTI") {
            return `${API_URL}/AwakNoHelpForPatti?Company_Code=${CompanyCode}`;
        }
        return `${API_URL}/AwakNoHelp?Company_Code=${CompanyCode}`;
    };



    const fetchAndOpenPopup = async () => {
        try {
            lActiveInputFeild = name;
            const response = await axios.get(getHelpApiUrl());
            const data = response.data;
            console.log("fetchAndOpenPopup", data)
            console.log("farmerCode received:", farmerCode);

            const filteredData = data.filter(item => {
                const matchesFarmer = enableFarmerFilter
                    ? (farmerCode ? Number(item.Ac_code) === Number(farmerCode) : true)
                    : true;

                const matchesSearch =
                    // item.System_Name_E?.toLowerCase().includes(searchTerm.toLowerCase()) ||
                    item.FarmerName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
                    item.Doc_No?.toString().includes(searchTerm);
                return matchesFarmer && matchesSearch;
            });

            setPopupContent(filteredData);
            setShowModal(true);

        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };



    // Handle Mill Code button click
    const handleMillCodeButtonClick = () => {
        lActiveInputFeild = name
        fetchAndOpenPopup();
        // if (onAcCodeClick) {
        //     onAcCodeClick({ enteredAcCode });
        // }
    };


    const handleCloseModal = () => {
        setShowModal(false);
    };

    const handleAcCodeChange = async (event) => {
        const { value } = event.target;
        setEnteredAcCode(value);
        try {
            // const response = await axios.get(`${API_URL}/AwakNoHelp?Company_Code=${CompanyCode}&Year_Code=${Year_Code}`);
            const response = await axios.get(
                helpMode === "ADVANCE"
                    ? `${API_URL}/AwakNoHelpForAdvance?Company_Code=${CompanyCode}`
                    : `${API_URL}/AwakNoHelp?Company_Code=${CompanyCode}`
            );

            const data = response.data;
            console.log("Data", data)
            setPopupContent(data);
            setApiDataFetched(true);
            const matchingItem = data.find((item) => item.Doc_No === parseInt(value, 10));
            if (matchingItem) {

                setEnteredAcCode(matchingItem.Doc_No);
                // setType(matchingItem.Tran_Type)
                setEnteredProformaid(matchingItem.Id)
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };


    const fetchSaleBillData = async (Id) => {
        try {
            let url = "";

            if (helpMode === "ADVANCE") {
                // Hit the Advance API
                url = `${API_URL}/getdata-AwakEntryByidForAdvancehelp?Company_Code=${CompanyCode}&Year_Code=${Year_Code}&Id=${Id}`;
            } else {
                // Hit the normal SALE API
                url = `${API_URL}/getdata-AwakEntryByidForhelp?Company_Code=${CompanyCode}&Year_Code=${Year_Code}&Id=${Id}`;
            }

            const response = await axios.get(url);
            const fetchedData = response.data;

            onFetchedData(fetchedData);
        } catch (error) {
            console.error("Error fetching SaleBill data:", error);
        }
    };


    // const handleRecordDoubleClick = async (item) => {
    //     debugger


    //     // if (isAwakNoHelp && item.Patti_No && Number(item.Patti_No) !== 0) {
    //     //     await Swal.fire({
    //     //         title: "Selection Not Allowed",
    //     //         text: "You cannot select this record because Patti is Made For this Bill.Adjust it From Awak Entry Form",
    //     //         icon: "warning",
    //     //         confirmButtonText: "OK",
    //     //     });
    //     //     return;
    //     // }
    //     if (lActiveInputFeild === name) {
    //         setEnteredAcCode(item.Doc_No);
    //         setEnteredProformaid(item.Id); // primary key
    //         setSelectedItemId(item.Id); // select row properly

    //         if (enableFetchData && item.Id) {
    //             fetchSaleBillData(item.Id); // fetch using primary key
    //         }

    //         if (onAcCodeClick) {
    //             onAcCodeClick(item.Doc_No, item.Id, item.Ac_code, item.ac, item.FarmerName);
    //         }

    //         console.log("Clicked Row:", item.Doc_No, item.Id, item.Ac_code, item.ac, item.FarmerName);
    //     }
    //     setShowModal(false);
    // };


    const handleRecordDoubleClick = async (item) => {
        if (lActiveInputFeild === name) {
            setEnteredAcCode(item.Doc_No);
            setEnteredProformaid(item.Id);
            setSelectedItemId(item.Id);

            // NEW: store details for the label
            setSelectedFarmerName(item.FarmerName || "");
            setSelectedAwakDate(item.Doc_Date || "");
            setSelectedQty(item.Awak_Qty ?? item.AwakQty ?? "");

            if (enableFetchData && item.Id) {
                fetchSaleBillData(item.Id);
            }

            if (onAcCodeClick) {
                onAcCodeClick(item.Doc_No, item.Id, item.Ac_code, item.ac, item.FarmerName);
            }
        }
        setShowModal(false);
    };

    const handlePageChange = (newPage) => {
        setCurrentPage(newPage);

    };



    const handleSearch = (searchValue) => {
        setSearchTerm(searchValue);
    };

    const filteredData = popupContent.filter(item =>
        item.Doc_No?.toString().includes(searchTerm) ||
        item.FarmerName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.Ac_code?.toString().includes(searchTerm)
    );


    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    const itemsToDisplay = filteredData.slice(startIndex, endIndex);

    console.log('item', itemsToDisplay)



    useEffect(() => {
        if (helpMode === "PATTI") {
            setSelectedPattiRows({});
        }
    }, [resetSelectionTrigger]);



    // useEffect(() => {
    //     if (Doc_No && DetailId) {
    //         setEnteredAcCode(Doc_No);
    //         setEnteredProformaid(DetailId);
    //         setSelectedItemId(Number(DetailId)); // Ensure numeric match
    //     } else {
    //         setEnteredAcCode("");
    //         setEnteredProformaid("");
    //         setSelectedItemId(null);
    //     }
    // }, [Doc_No, DetailId]);
    useEffect(() => {
        const loadSelectedRecordDetails = async () => {
            if (Doc_No && DetailId) {
                setEnteredAcCode(Doc_No);
                setEnteredProformaid(DetailId);
                setSelectedItemId(Number(DetailId));

                // If the popup double-click already set this exact record's
                // details, don't re-fetch — avoids an extra API call.
                if (selectedItemId === Number(DetailId) && selectedFarmerName) {
                    return;
                }

                try {
                    const response = await axios.get(getHelpApiUrl());
                    const data = response.data;
                    const matched = data.find(
                        (item) => Number(item.Id) === Number(DetailId)
                    );
                    if (matched) {
                        setSelectedFarmerName(matched.FarmerName || "");
                        setSelectedAwakDate(matched.Doc_Date || "");
                        setSelectedQty(matched.Awak_Qty ?? matched.AwakQty ?? "");
                    }
                } catch (error) {
                    console.error("Error fetching selected Awak record details:", error);
                }
            } else {
                setEnteredAcCode("");
                setEnteredProformaid("");
                setSelectedItemId(null);
                setSelectedFarmerName("");
                setSelectedAwakDate("");
                setSelectedQty("");
            }
        };

        loadSelectedRecordDetails();
    }, [Doc_No, DetailId]);

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === "F1") {
                if (event.target.id === name) {
                    lActiveInputFeild = name;
                    setSearchTerm(event.target.value);
                    fetchAndOpenPopup();
                    event.preventDefault();
                }
            }
        };

        window.addEventListener("keydown", handleKeyDown);
        return () => {
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, [name, fetchAndOpenPopup]);




    useEffect(() => {
        const handleKeyNavigation = (event) => {
            if (!showModal) return;

            // 🚫 Do NOT trap keys when clicking checkbox / close button
            const tag = event.target.tagName;
            if (tag === "INPUT" || tag === "BUTTON") return;

            if (itemsToDisplay.length === 0) return;

            let currentIndex = itemsToDisplay.findIndex(
                item => item.Id === selectedItemId
            );

            if (currentIndex === -1) {
                setSelectedItemId(itemsToDisplay[0].Id);
                return;
            }

            if (event.key === "ArrowUp") {
                event.preventDefault();
                setSelectedItemId(itemsToDisplay[Math.max(currentIndex - 1, 0)].Id);
            }

            if (event.key === "ArrowDown") {
                event.preventDefault();
                setSelectedItemId(
                    itemsToDisplay[Math.min(currentIndex + 1, itemsToDisplay.length - 1)].Id
                );
            }

            if (event.key === "Enter") {
                event.preventDefault();
                handleRecordDoubleClick(itemsToDisplay[currentIndex]);
            }
        };

        window.addEventListener("keydown", handleKeyNavigation);
        return () => window.removeEventListener("keydown", handleKeyNavigation);
    }, [showModal, selectedItemId, itemsToDisplay]);


    const handlePattiCheckboxChange = (Doc_No) => {
        setSelectedPattiRows(prev => ({
            ...prev,
            [Doc_No]: !prev[Doc_No]
        }));
    };

    useEffect(() => {
        if (helpMode === "PATTI" && onAcCodeClick) {
            const selectedDocNos = Object.keys(selectedPattiRows)
                .filter(docNo => selectedPattiRows[docNo])
                .map(Number);

            //  ALWAYS call — even when empty
            onAcCodeClick({
                helpMode: "PATTI",
                selectedDocNos,
            });
        }
    }, [selectedPattiRows]);



    useEffect(() => {
        const updatedSelected = { ...selectedPattiRows };
        Object.keys(selectedPattiRows).forEach(docNo => {
            const item = popupContent.find(i => i.Doc_No === Number(docNo));
            if (item && item.desp === 0) {
                delete updatedSelected[docNo];
            }
        });
        setSelectedPattiRows(updatedSelected);
    }, [popupContent]);




    console.log('PopUp Content', popupContent)

    return (
        <div className="d-flex flex-row ">
            <div className="d-flex ">
                <div className="d-flex">
                    <input
                        type="text"
                        className="form-control ms-2"
                        id={name}
                        autoComplete="off"
                        value={enteredAcCode}
                        onChange={handleAcCodeChange}
                        // onKeyDown={handleKeyDown}
                        style={{ width: "100px", height: "35px" }}
                        tabIndex={tabIndexHelp}
                        disabled={disabledFeild}
                        ref={firstInputRef}
                        farmerCode={farmerCode}
                    />
                    <Button
                        variant="primary"
                        onClick={handleMillCodeButtonClick}
                        className="ms-1"
                        style={{ width: "30px", height: "35px" }}
                        disabled={false}
                    >
                        ...
                    </Button>
                    {/* <label id="name" className="form-labels ms-2" style={{ whiteSpace: 'nowrap', fontSize: "14px", fontWeight: "bold", marginTop: "5px" }}>
                        Awak Id - {String(enteredProformaid)}
                    </label> */}
                    <label id="name" className="form-labels ms-2" style={{ whiteSpace: 'nowrap', fontSize: "14px", fontWeight: "bold", marginTop: "5px" }}>
                        {selectedFarmerName && (
                            <span>{selectedFarmerName}</span>
                        )}
                        {selectedAwakDate && (
                            <>
                                {selectedFarmerName && <span style={{ color: "#000" }}>, </span>}
                                <span style={{ color: "#FBC02D" }}>{selectedAwakDate}</span>
                            </>
                        )}
                        {selectedQty !== "" && selectedQty != null && (
                            <>
                                {(selectedFarmerName || selectedAwakDate) && <span style={{ color: "#000" }}>, </span>}
                                <span style={{ color: "#2e7d32" }}>{selectedQty}</span>
                            </>
                        )}
                    </label>
                </div>
            </div>
            <Modal
                show={showModal}
                onHide={handleCloseModal}
                centered
                backdrop={showPreviewModal ? false : true}
                dialogClassName={`
                        transition-all duration-300 ease-in-out
                        ${showPreviewModal ? "opacity-20 pointer-events-none" : ""}
                    `}

                contentClassName={`
                        rounded-lg shadow-lg
                        ${showPreviewModal ? "bg-dark text-white" : ""}
                    `}

            >
                <Modal.Header style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Modal.Title>Awak Help</Modal.Title>
                    <Button
                        style={{ background: 'none', border: 'none', fontSize: '1.5rem', cursor: 'pointer', color: 'blue' }}
                        onClick={handleCloseModal}
                    >
                        X
                    </Button>
                </Modal.Header>
                <DataTableSearch data={popupContent} onSearch={handleSearch} />
                <Modal.Body>
                    {Array.isArray(popupContent) ? (
                        <div style={{ overflowX: "auto" }}>
                            <table style={{
                                width: "100%",
                                borderCollapse: "collapse",
                                marginBottom: "1rem",
                                backgroundColor: "#fff",
                            }}>
                                <thead style={{ backgroundColor: "#f8f9fa" }}>
                                    <tr>
                                        {!isPattiHelp && (
                                            <th style={{ border: "1px solid #dee2e6", padding: "8px", whiteSpace: "nowrap" }}>Id</th>
                                        )}

                                        <th style={{ border: "1px solid #dee2e6", padding: "1px", whiteSpace: "nowrap" }}>Awak No</th>
                                        <th style={{ border: "1px solid #dee2e6", padding: "8px", whiteSpace: "nowrap" }}>Awak Date</th>
                                        <th style={{ border: "1px solid #dee2e6", padding: "8px", whiteSpace: "nowrap" }}>Item Name</th>
                                        {/* <th style={{ border: "1px solid #dee2e6", padding: "2px", whiteSpace: "nowrap" }}>Farmer Code</th>
                                        <th style={{ border: "1px solid #dee2e6", padding: "8px", whiteSpace: "nowrap" }}>Farmer Name</th> */}

                                        {/* {isAwakNoHelp ? (
                                        <>
                                            <th style={{ border: "1px solid #dee2e6", padding: "8px", whiteSpace: "nowrap" }}>Despatched</th>
                                            <th style={{ border: "1px solid #dee2e6", padding: "8px", whiteSpace: "nowrap" }}>Balance</th>
                                        </>
                                        ) : (
                                        <th style={{ border: "1px solid #dee2e6", padding: "8px", whiteSpace: "nowrap" }}>Customer Code</th> */}
                                        {isAwakNoHelp && (
                                            <>
                                                <th style={{ border: "1px solid #dee2e6", padding: "2px", whiteSpace: "nowrap" }}>Farmer Code</th>
                                                <th style={{ border: "1px solid #dee2e6", padding: "8px", whiteSpace: "nowrap" }}>Farmer Name</th>
                                                <th style={{ border: "1px solid #dee2e6", padding: "8px", whiteSpace: "nowrap" }}>Qty</th>
                                                <th style={{ border: "1px solid #dee2e6", padding: "8px", whiteSpace: "nowrap" }}>Despatched</th>
                                                <th style={{ border: "1px solid #dee2e6", padding: "8px", whiteSpace: "nowrap" }}>Balance</th>
                                                <th style={{ border: "1px solid #dee2e6", padding: "8px", whiteSpace: "nowrap" }}>Patti No</th>
                                            </>
                                        )}
                                        {helpMode === "PATTI" && (
                                            <>
                                                <th style={{ border: "1px solid #dee2e6", padding: "8px", whiteSpace: "nowrap" }}>Qty</th>
                                                <th style={{ border: "1px solid #dee2e6", padding: "8px", whiteSpace: "nowrap" }}>Quantity Without Patti</th>
                                                {/* <th style={{ border: "1px solid #dee2e6", padding: "8px", whiteSpace: "nowrap" }}>Patti quantity</th> */}
                                                <th style={{ border: "1px solid #dee2e6", padding: "8px", whiteSpace: "nowrap" }}>Balance</th>
                                                <th style={{ border: "1px solid #dee2e6", padding: "8px", whiteSpace: "nowrap" }}>
                                                    Select
                                                </th>
                                            </>
                                        )}
                                        {/* <th style={{ border: "1px solid #dee2e6", padding: "8px", whiteSpace: "nowrap" }}>Auction Mark</th> */}
                                    </tr>
                                </thead>
                                <tbody>
                                    {itemsToDisplay.map((item, index) => (
                                        <tr
                                            key={`${item.Doc_No}-${index}`}
                                            className={selectedItemId === item.Id ? "selected-row" : ""}
                                            onDoubleClick={() => handleRecordDoubleClick(item)}
                                        >
                                            {!isPattiHelp && (
                                                <td style={{ border: "1px solid #dee2e6", padding: "8px" }}>{item.Id}</td>
                                            )}
                                            <td style={{ border: "1px solid #dee2e6", padding: "8px" }}>{item.Doc_No}</td>
                                            <td style={{ border: "1px solid #dee2e6", padding: "8px" }}>{item.Doc_Date}</td>
                                            <td style={{ border: "1px solid #dee2e6", padding: "8px" }}>{item.System_Name_E}</td>


                                            {/* {isAwakNoHelp ? (
                                        <>
                                            <td style={{ border: "1px solid #dee2e6", padding: "8px" }}>{item.despatched}</td>
                                            <td style={{ border: "1px solid #dee2e6", padding: "8px" }}>{item.balance}</td>
                                        </>
                                        ) : (
                                        <td style={{ border: "1px solid #dee2e6", padding: "8px" }}>{item.Customer_Code}</td> */}
                                            {isAwakNoHelp && (
                                                <>
                                                    <td style={{ border: "1px solid #dee2e6", padding: "8px" }}>{item.Ac_code}</td>
                                                    <td style={{ border: "1px solid #dee2e6", padding: "8px" }}>{item.FarmerName}</td>
                                                    <td style={{ border: "1px solid #dee2e6", padding: "8px" }}>{item.Awak_Qty}</td>
                                                    <td style={{ border: "1px solid #dee2e6", padding: "8px" }}>{item.despatched}</td>
                                                    <td style={{ border: "1px solid #dee2e6", padding: "8px" }}>{item.balance}</td>
                                                    <td style={{ border: "1px solid #dee2e6", padding: "8px" }}>{item.Patti_No}</td>
                                                </>
                                            )}


                                            {helpMode === "PATTI" && (
                                                <>
                                                    <td style={{ border: "1px solid #dee2e6", padding: "8px" }}>{item.AwakQty}</td>
                                                    <td style={{ border: "1px solid #dee2e6", padding: "8px" }}>{item.QuantityWithoutPatti}</td>
                                                    {/* <td style={{ border: "1px solid #dee2e6", padding: "8px" }}>{item.PattiQuantity}</td> */}
                                                    <td style={{ border: "1px solid #dee2e6", padding: "8px" }}>{item.balance}</td>
                                                    <td style={{ border: "1px solid #dee2e6", padding: "8px", textAlign: "center" }}>
                                                        <input
                                                            type="checkbox"
                                                            checked={item.QuantityWithoutPatti > 0 && !!selectedPattiRows[item.Doc_No]}
                                                            disabled={item.QuantityWithoutPatti === 0}
                                                            onChange={() => {
                                                                if (item.QuantityWithoutPatti > 0) {
                                                                    handlePattiCheckboxChange(item.Doc_No);
                                                                }
                                                            }}
                                                            onClick={(e) => e.stopPropagation()}
                                                        />

                                                    </td>
                                                </>
                                            )}

                                            {/* )} */}
                                            {/* <td style={{ border: "1px solid #dee2e6", padding: "8px" }}>{item.AuctionMark}</td> */}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    ) : (
                        "Loading..."
                    )}
                </Modal.Body>

                <Modal.Footer>
                    <DataTablePagination
                        totalItems={filteredData.length}
                        itemsPerPage={itemsPerPage}
                        onPageChange={handlePageChange}
                    />
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default AwakEntryhelp;